"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jobFilterFieldsOrder = exports.IntroEmailsAccount = exports.SubmissionAccount = exports.JobSubmissionType = exports.JobStatus = exports.jobPrepayRequired = exports.hasFlag = exports.JOB_FLAG_SCORING_BRIEF_ENABLED = exports.JOB_FLAG_JD_LLM_UPDATE_ENABLED = exports.JOB_FLAG_ROUND_ROBIN_SCHEDULING = exports.JOB_FLAG_IGNORE_OUTREACH_COOLDOWN = exports.JOB_FLAG_INTRO_EMAILS_SUPPORTED = exports.JOB_FLAG_USE_CENTRAL_SUBMISSION_EMAIL = exports.jobPriorityToString = exports.visaOptToString = exports.diversityOptToString = exports.hasJobPermission = void 0;
function hasJobPermission(permissions, userId) {
    return (permissions &&
        ((permissions.allowAll && permissions.disallowedUserIds.indexOf(userId) === -1) ||
            permissions.allowedUserIds.indexOf(userId) !== -1));
}
exports.hasJobPermission = hasJobPermission;
function diversityOptToString(opt) {
    switch (opt) {
        case 'diversity_only':
            return 'Diversity Only';
        case 'diversity_preferred':
            return 'Diversity Preferred';
        case 'not_relevant':
            return 'Not Relevant';
        default:
            return '';
    }
}
exports.diversityOptToString = diversityOptToString;
function visaOptToString(opt) {
    switch (opt) {
        case 'no_visa':
            return 'No Visa Sponsorship';
        case 'h1_transfers':
            return 'Visa Transfers OK';
        case 'h1_sponsorships':
            return 'New Visa Sponsorship OK';
        case 'tn_visa':
            return 'TN Visa OK';
        default:
            return '';
    }
}
exports.visaOptToString = visaOptToString;
function jobPriorityToString(priority) {
    switch (priority) {
        case 'p1':
            return 'P1';
        case 'p2':
            return 'P2';
        case 'p3':
            return 'P3';
        default:
            return '';
    }
}
exports.jobPriorityToString = jobPriorityToString;
// tslint:disable:no-magic-numbers no-bitwise
exports.JOB_FLAG_USE_CENTRAL_SUBMISSION_EMAIL = 0x00000001;
exports.JOB_FLAG_INTRO_EMAILS_SUPPORTED = 0x00000002;
exports.JOB_FLAG_IGNORE_OUTREACH_COOLDOWN = 0x00000004;
exports.JOB_FLAG_ROUND_ROBIN_SCHEDULING = 0x00000008;
exports.JOB_FLAG_JD_LLM_UPDATE_ENABLED = 0x00000040;
exports.JOB_FLAG_SCORING_BRIEF_ENABLED = 0x00000080;
function hasFlag(job, flag) {
    return (job.flags & flag) !== 0;
}
exports.hasFlag = hasFlag;
function jobPrepayRequired(jobType) {
    return ['C+$', 'CnC+$', 'R'].includes(jobType);
}
exports.jobPrepayRequired = jobPrepayRequired;
var JobStatus;
(function (JobStatus) {
    JobStatus[JobStatus["Active"] = 1] = "Active";
    JobStatus[JobStatus["Paused"] = 2] = "Paused";
    JobStatus[JobStatus["Archived"] = 3] = "Archived";
})(JobStatus = exports.JobStatus || (exports.JobStatus = {}));
var JobSubmissionType;
(function (JobSubmissionType) {
    JobSubmissionType["Email"] = "email";
    JobSubmissionType["ATS"] = "ats";
    JobSubmissionType["Slack"] = "slack";
})(JobSubmissionType = exports.JobSubmissionType || (exports.JobSubmissionType = {}));
exports.SubmissionAccount = 'submissions@getrocket.com';
exports.IntroEmailsAccount = 'introductions@getrocket.com';
exports.jobFilterFieldsOrder = [
    'curated-hot',
    'curated-new',
    'headcount',
    'experience',
    'discipline',
    'visa',
    'diversity',
    'skills',
    'location',
    'group',
    'keywords',
    'keywords-and',
    'anywhere'
];
//# sourceMappingURL=job.js.map